import { rejectInvalidSyncKey } from 'serviceWorker/services/factories/invalidSyncKey';

import {
  defaultConfig,
  generateHeaders,
  makeNormalizeResponse,
} from '../../helpers/httpRequests';
import { HeadersData } from '../factories/types';
import { pull } from '../pull';

const parseResponse = makeNormalizeResponse('templates');

export const fetchInspectionTemplates = (
  data: HeadersData,
  controller: AbortController
): Promise<any> | undefined => {
  const { signal } = controller;
  if (shouldSkip(data, signal)) {
    return;
  }
  const builtUrl = `${data.api}/v2/project/${data.projectId}/inspectionTemplate`;

  return pull(builtUrl, {
    ...defaultConfig,
    method: 'GET',
    headers: generateHeaders(data),
    signal,
  }).then(parseResponse);
};

export const fetchUpdatedInspectionTemplates = (
  data: HeadersData,
  syncKey: string,
  controller: AbortController
): Promise<any> | undefined => {
  const { signal } = controller;
  if (!data.api || !data.projectId) {
    //not enough data, skip.
    return;
  }
  const builtUrl = `${data.api}/v2/project/${
    data.projectId
  }/inspectionTemplate?syncKey=${encodeURIComponent(syncKey)}`;

  return pull(builtUrl, {
    ...defaultConfig,
    method: 'GET',
    headers: generateHeaders(data),
    signal,
  })
    .then((response: Response) => rejectInvalidSyncKey(response, 'inspectionTemplates'))
    .then(parseResponse);
};

function shouldSkip(data: HeadersData, signal: AbortSignal): boolean {
  return !data.api || !data.projectId || signal.aborted;
}
